import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'HttpHeadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-head",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 16v-8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 8v8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 12h2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 16v-6a2 2 0 1 1 4 0v6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 13h4"
    }, null), _createTextVNode(" ")]);
  }
};